
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../_actions";
import StudentHeader from "./Component/StudentHeader";
import ViewAssessentCodes from "./Modal/ViewAssessentCodes"
// import { IoIosArrowForward } from "react-icons/io";
import { IoIosSearch } from "react-icons/io";
import { LiaFileExcel } from "react-icons/lia";
import { TbPasswordUser } from "react-icons/tb";
import { PiStudent } from "react-icons/pi";
import Select from 'react-select';
import moment from "moment";


class MyOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmployeeModal: false,
      showAssessmentCodesModal: false
    };
  }

  componentDidMount() {

    this.props.dispatch(assessmentActions.getDashboardAnalytics({
      type: 2
    }));

    this.props.dispatch(assessmentActions.getAssessmentCodeByTimestamp({}))
    window.scrollTo(0, 0);
  }

  handleNewSchoolModal = (value) => {
    this.setState({ showEmployeeModal: value });
  };

  gotoPage2 = (field) => {
    const { history } = this.props;
    history.push(`/assessment/${field}`);
  };

  handleShowAssessmentCode = (value) => {
    this.setState({ showAssessmentCodesModal: value })
  }

  render() {

    let { assessment } = this.props;
    let { getAssessmentCodeByTimestampData, getDashboardAnalyticsData } = assessment;
    let { showAssessmentCodesModal } = this.state;

    // const data = [
    //   { id: 1, name: 'Norma singh', email: 'Norma@gmail.com', date: '16th July, 2024 |  4:20 PM', role: 'Counselor', codes: '100', status: '56', action: 'View All Assessment Codes' },
    //   { id: 2, name: 'John Dey', email: 'john@gmail.com', date: '17th July, 2024 |  5:20 PM', role: 'Advisor', codes: '500', status: '30', action: 'View All Assessment Codes' },
    //   { id: 3, name: 'Jane Singh', email: 'jane@gmail.com', date: '18th July, 2024 |  4:20 PM', role: 'Teacher', codes: '456', status: '100', action: 'View All Assessment Codes' },
    //   { id: 4, name: 'Doe Roy', email: 'doe@gmail.com', date: '19th July, 2024 |  4:20 PM', role: 'Engineer', codes: '302', status: '56', action: 'View All Assessment Codes' },
    //   { id: 5, name: 'Alice Ali', email: 'alice@gmail.com', date: '20th July, 2024 |  6:20 PM', role: 'Designer', codes: '95', status: '30', action: 'View All Assessment Codes' },
    //   { id: 6, name: 'Bob Bobby', email: 'bob@gmail.com', date: '21th July, 2024 |  4:20 PM', role: 'Manager', codes: '100', status: '100', action: 'View All Assessment Codes' },
    //   { id: 7, name: 'Charlie Mark', email: 'charlie@gmail.com', date: '22th July, 2024 |  4:20 PM', role: 'Developer', codes: '100', status: '56', action: 'View All Assessment Codes' },
    //   { id: 8, name: 'David Dev', email: 'david@gmail.com', date: '23th July, 2024 |  4:20 PM', role: 'Analyst', codes: '45', status: '30', action: 'View All Assessment Codes' },
    //   { id: 9, name: 'Eve Freeri', email: 'eve@gmail.com', date: '24th July, 2024 |  4:20 PM', role: 'Consultant', codes: '10', status: '56', action: 'View All Assessment Codes' },
    //   { id: 10, name: 'Frank Fev', email: 'frank@gmail.com', date: '25th July, 2024 |  4:20 PM', role: 'Specialist', codes: '260', status: '56', action: 'View All Assessment Codes' },
    // ];





    const checkFormat = (ele, field, type) => {
      if (type === "list") {
        return ele && ele[field] && ele[field].length > 0 ? ele[field] : []
      } else {
        return ele && ele[field] ? ele[field] : ""
      }
    }

    const data = getAssessmentCodeByTimestampData && getAssessmentCodeByTimestampData.length > 0 ?
      getAssessmentCodeByTimestampData.map((ele, index) => ({
        id: index + 1,
        list: checkFormat(ele, "purchaserOrderId", "list"),
        date: checkFormat(ele, "createdAt")
          ? moment(checkFormat(ele, "createdAt"))
            .utcOffset("+05:30")
            .format("DD MMMM, YYYY | hh:mm A")
          : "",
        codes: checkFormat(ele, "purchaserOrderId", "list").length,
        status: 'UnAssigned'
      })) : []



    const colourOptions = [
      { value: 'All', label: 'All' },
      { value: 'Mountainridge School', label: 'Mountainridge School' },
      { value: 'Springfield Technical School', label: 'Springfield Technical School' },
      { value: 'South Fork Grammar School', label: 'South Fork Grammar School' },
      { value: 'Spring Technical School', label: 'Springfield Technical School' },
    ]

    return (
      <>
        <StudentHeader />

        <div className="flex items-start justify-center pb-10 bg-[#FAFAFA]">
          <section className="px-4 xl:w-11/12 mx-auto w-full xl:px-0">

            <div className="my-4 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <div className="bg-white border border-[#E8E8E8] rounded-lg p-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <h3 className="text-base font-normal text-gray-500">Total Codes</h3>
                    <span className="text-2xl sm:text-3xl leading-none font-semibold text-gray-900">{
                      getDashboardAnalyticsData && getDashboardAnalyticsData.total ? getDashboardAnalyticsData.total : 0
                    }</span>
                  </div>
                  <div className="flex items-center justify-end flex-1 text-[#2196F3] text-base font-bold">
                    <img src="/assessment_images/School/total-school.svg" alt="total-school.svg" className="w-16 h-16" />
                  </div>
                </div>
              </div>
              <div className="bg-white border border-[#E8E8E8] rounded-lg p-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <h3 className="text-base font-normal text-gray-500">Total Assigned Codes</h3>
                    <span className="text-2xl sm:text-3xl leading-none font-semibold text-gray-900">{
                      getDashboardAnalyticsData && getDashboardAnalyticsData.count1 ? getDashboardAnalyticsData.count1 : 0
                    }</span>
                  </div>
                  <div className="flex items-center justify-end flex-1 text-[#2196F3] text-base font-bold">
                    <PiStudent className="w-16 h-16" />
                  </div>
                </div>
              </div>
              <div className="bg-white border border-[#E8E8E8] rounded-lg p-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <h3 className="text-base font-normal text-gray-500">Total Unassigned Codes</h3>
                    <span className="text-2xl sm:text-3xl leading-none font-semibold text-gray-900">{
                      getDashboardAnalyticsData && getDashboardAnalyticsData.count0 ? getDashboardAnalyticsData.count0 : 0
                    }</span>
                  </div>
                  <div className="flex items-center justify-end flex-1 text-[#2196F3] text-base font-bold">
                    <TbPasswordUser className="w-16 h-16" />
                  </div>
                </div>
              </div>
            </div>


            <div className="bg-white border p-4">

              <div className="w-full flex-1 space-y-4">
                <div className="items-stretch justify-between space-y-4 lg:flex md:space-x-6 md:space-y-0">
                  <div className="flex space-x-3 items-center">
                    <div className="flex space-x-2 capitalize items-center text-sm text-[#212121]/70 font-medium">
                      <span>Show</span>
                      <form class="w-16">
                        <select id="entries" class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full px-2 py-1.5 focus:outline-none">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </form>
                      <span>entries</span>
                    </div>
                    <div className="space-y-1">
                      <div className="relative w-full ">
                        <Select className="w-56 text-[#212121] text-sm"
                          options={colourOptions}
                          defaultValue={colourOptions[0]}
                          placeholder="Select School"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex space-x-4">
                    {/* <div className="w-full flex justify-between border px-4 text-[#212121]/70 bg-white rounded-md text-sm items-center  overflow-hidden">
                      <IoIosSearch className="w-5 h-5" />
                      <input type="search" name="search" placeholder="Search by name" className="w-44 focus:outline-none px-2 py-2 text-[#212121]/70 placeholder-[#212121]/70 placeholder:font-normal font-medium " />
                    </div> */}

                    <div className="flex items-center py-3 px-4 text-sm border whitespace-nowrap rounded-md cursor-pointer font-medium text-[#212121]/70 md:w-auto w-full" >
                      <span className="mr-2 " >
                        <LiaFileExcel className="w-5 h-5" />
                      </span> Download Excel
                    </div>
                  </div>
                </div>

                {/* Table design secction */}
                <div className="w-full mx-auto">
                  <div className="inline-block min-w-full">
                    <table className="min-w-full border">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-3 w-16 py-3 text-center border text-sm font-semibold text-gray-900">S.No.</th>
                          <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Receiving Date</th>
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Assessment Codes</th>
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Assigned Code</th>
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="border divide-gray-200 bg-white">
                        {data.slice(0, 10).map((item) => (
                          <tr className="hover:bg-gray-100">
                            <td className="whitespace-nowrap px-2 py-2 border text-sm text-center">{item.id}</td>
                            <td className="whitespace-nowrap px-2 py-2 border text-sm text-left">{item.date}</td>

                            <td className="whitespace-nowrap px-2 py-2 border text-sm">
                              <div className="flex items-center justify-center">{item.codes}</div>
                            </td>

                            <td className="whitespace-nowrap px-2 py-2 border text-sm">
                              <div className="flex items-center justify-center">{item.status} Codes</div>
                            </td>

                            <td className="whitespace-nowrap px-2 py-2 border text-sm">
                              <div onClick={() => this.handleShowAssessmentCode(item)} className="flex items-center justify-center">
                                <div className="bg-white cursor-pointer text-center text-sm rounded-md px-3 py-1.5 focus:outline-none text-[#2196F3] border border-[#2196F3]">
                                  {"View All Assessment Codes"}
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </div>
                </div>

              </div>





              {/* Data not Found section */}
              {/* <section className="flex items-center justify-center w-full col-span-2 gap-10 px-4 mx-auto overflow-hidden">
                <div className="flex flex-col items-center space-y-4 justify-center md:py-10 py-8 text-center">
                  <img src="/assessment_images/no-users.svg" alt="no-users.svg" className="w-3/6 2xl:w-2/4" />
                  <h2 className="capitalize md:text-3xl text-2xl font-semibold text-[#3D405B] pt-4">Data not found!</h2>
                  <p className="text-gray-500 text-lg">Looks like you haven’t added any user yet.</p>
                  <div onClick={() => this.handleNewSchoolModal(true)} className="mt-0 md:mt-4 bg-[#2196F3] border border-[#2196F3] text-white py-2 px-5 rounded uppercase flex items-center justify-center space-x-3">
                    <span><svg width="30" height="30" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M30.3281 40H50.3281M40.3281 30V50M10.3281 40C10.3281 43.9397 11.1041 47.8407 12.6117 51.4805C14.1194 55.1203 16.3292 58.4274 19.1149 61.2132C21.9007 63.999 25.2079 66.2087 28.8476 67.7164C32.4874 69.224 36.3885 70 40.3281 70C44.2678 70 48.1689 69.224 51.8086 67.7164C55.4484 66.2087 58.7556 63.999 61.5413 61.2132C64.3271 58.4274 66.5369 55.1203 68.0445 51.4805C69.5522 47.8407 70.3281 43.9397 70.3281 40C70.3281 36.0603 69.5522 32.1593 68.0445 28.5195C66.5369 24.8797 64.3271 21.5726 61.5413 18.7868C58.7556 16.001 55.4484 13.7913 51.8086 12.2836C48.1689 10.776 44.2678 10 40.3281 10C36.3885 10 32.4874 10.776 28.8476 12.2836C25.2079 13.7913 21.9007 16.001 19.1149 18.7868C16.3292 21.5726 14.1194 24.8797 12.6117 28.5195C11.1041 32.1593 10.3281 36.0603 10.3281 40Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></span>
                    <button className="">Add New School</button>
                  </div>
                </div>
              </section> */}



            </div>


          </section>
        </div>

        {showAssessmentCodesModal && showAssessmentCodesModal.list && showAssessmentCodesModal.list.length > 0 ? (
          <>
            <ViewAssessentCodes
              closeModal={this.handleShowAssessmentCode}
              createdAt={showAssessmentCodesModal.date}
              data={showAssessmentCodesModal.list}
            />
          </>
        ) : null}



      </>
    );
  }
}

MyOrders.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(MyOrders);
